import {Text, Lesson, Info } from './reducer_helper';

const defaultState = {
  completions: {},
  url: {poet: '', poem: '', id: ''},
  data: {},
  text: new Text(),
  info: new Info(),
  lesson: new Lesson()
};

export default
function course(state = defaultState, action) {
  switch(action.type) {
    case 'UPDATE_URL':
      return Object.assign({}, state, {
        url: action.url
      });
    case 'REQUEST_COURSE_DATA':
      return Object.assign({}, state, {
        length: action.length,
        data: action.data,
        text: action.text,
        lesson: action.lesson,
        info: action.info,
        url: action.url
      });
    case 'FETCH_USER':
      return Object.assign({}, state, {
        user: action.user || false
      });
    case 'LOGOUT_USER':
      return Object.assign({}, state, {
        user: false
      });
    case 'CHANGE_LESSON':
      return Object.assign({}, state, {
        lesson: action.lesson,
        info: action.info,
        mountLesson: false,
        url: action.url
      });
    case 'MOUNT_LESSON':
      return Object.assign({}, state, {
        mountLesson: true
      });
    case 'UNMOUNT_LESSON':
      return Object.assign({}, state, {
        mountLesson: false
      });
    case 'UNMOUNT_POEM':
      return defaultState;
    case 'COMPLETE_LESSON':
      return Object.assign({}, state, {
        completions: {...state.completions, [action.lessonID]: true}
      }); 
    case 'REQUEST_COMPLETIONS':
      if(!action.completions) return state;
      return Object.assign({}, state, {
        completions: action.completions
      }); 
    case 'REMOVE_COMPLETION':
      return Object.assign({}, state, {
        completions: {...state.completions, [action.lessonID]: false}
      }); 
    default:
      return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/course.js